var _circle, _path, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRocket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rocket_svg__a)"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#EBF2EF"
})), /*#__PURE__*/React.createElement("mask", {
  id: "rocket_svg__b",
  width: 120,
  height: 120,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C6365B",
  d: "M119.998 59.946c0 33.107-26.798 59.946-59.856 59.946-33.057 0-59.855-26.839-59.855-59.946C.287 31.828 22.616 0 60.142 0c15.995 0 34.366 2.254 45.272 12.941 11.092 10.87 14.584 30.311 14.584 47.005Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#rocket_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "m58.116 75.074-6.67-6.867 52.528-53.08c-.37 25.018-30.727 50.389-45.858 59.947Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "M57.785 75.964a1.124 1.124 0 0 1-.8-.327L43.471 62.101a1.129 1.129 0 0 1-.158-1.388 156.222 156.222 0 0 1 18.166-23.316c14.584-15.353 29.27-23.475 42.48-23.475a1.123 1.123 0 0 1 1.126 1.128c0 13.232-8.108 27.941-23.436 42.55A156.031 156.031 0 0 1 58.37 75.795c-.176.11-.378.168-.585.17ZM45.7 61.142l12.241 12.262c5.845-3.757 43.843-29.25 44.891-57.226-27.93 1.049-53.382 39.11-57.132 44.964Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "M52.158 77.091a1.125 1.125 0 0 1-.8-.327l-9.01-9.024a1.13 1.13 0 0 1 0-1.602l3.38-3.384 1.599 1.602-2.59 2.583 7.421 7.434 2.579-2.595 1.6 1.602-3.38 3.384a1.125 1.125 0 0 1-.799.327ZM34.136 86.116a1.126 1.126 0 0 1-1.126-1.128 23.57 23.57 0 0 1 7.084-15.466l1.599 1.602a22.28 22.28 0 0 0-6.33 12.634 22.219 22.219 0 0 0 12.614-6.34l1.6 1.603a23.499 23.499 0 0 1-15.441 7.095Z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 74.699,
  cy: 44.359,
  fill: "#fff",
  rx: 4.262,
  ry: 4.269
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 84.891,
  cy: 34.151,
  fill: "#fff",
  rx: 4.262,
  ry: 4.269
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 64.51,
  cy: 54.566,
  fill: "#fff",
  rx: 4.262,
  ry: 4.269
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36485C",
  d: "M84.815 39.866a5.624 5.624 0 0 1-5.203-3.481 5.649 5.649 0 0 1 1.22-6.147 5.628 5.628 0 0 1 9.614 3.988 5.648 5.648 0 0 1-1.65 3.988 5.63 5.63 0 0 1-3.981 1.652Zm0-9.024a3.374 3.374 0 0 0-3.122 2.09 3.39 3.39 0 0 0 .733 3.687 3.377 3.377 0 0 0 5.767-2.393c0-.897-.356-1.758-.99-2.393a3.376 3.376 0 0 0-2.388-.991ZM74.678 50.019a5.625 5.625 0 0 1-5.203-3.482 5.649 5.649 0 0 1 1.221-6.147 5.628 5.628 0 0 1 9.613 3.989c0 1.495-.593 2.93-1.65 3.988a5.626 5.626 0 0 1-3.981 1.652Zm0-9.025a3.374 3.374 0 0 0-3.121 2.09 3.388 3.388 0 0 0 2.462 4.614 3.373 3.373 0 0 0 3.468-1.44 3.388 3.388 0 0 0-.42-4.272 3.375 3.375 0 0 0-2.39-.992ZM64.543 60.171a5.624 5.624 0 0 1-5.202-3.482 5.649 5.649 0 0 1 1.22-6.146 5.628 5.628 0 0 1 9.613 3.988 5.648 5.648 0 0 1-1.65 3.988 5.63 5.63 0 0 1-3.98 1.652Zm0-9.024a3.375 3.375 0 0 0-3.121 2.089 3.39 3.39 0 0 0 .732 3.688 3.376 3.376 0 0 0 5.768-2.393c0-.898-.356-1.758-.99-2.393a3.376 3.376 0 0 0-2.389-.991ZM74.68 86.116H63.416a1.125 1.125 0 0 1-1.126-1.128v-9.024h2.252v7.896h9.404L92.8 41.66l2.05.925-19.146 42.866a1.128 1.128 0 0 1-1.025.665ZM43.146 56.788h-9.01a1.125 1.125 0 0 1-1.126-1.128V44.379a1.128 1.128 0 0 1 .664-1.026L76.47 24.175l.923 2.053-42.13 18.883v9.42h7.883v2.256ZM101.708 27.459c-2.688 0-5.266-1.07-7.167-2.974a10.16 10.16 0 0 1-2.969-7.178h2.253c0 2.094.83 4.102 2.309 5.583a7.877 7.877 0 0 0 5.574 2.313v2.256Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.958,
  d: "M35.51 67.563C15.5 76.825-6.36 72.117-13.312 57.047M51.79 82.961c-16.614 14.514-21.25 36.422-10.356 48.934"
}))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 15.21,
  cy: 98.351,
  stroke: "#307553",
  strokeWidth: 0.979,
  rx: 1.878,
  ry: 1.881
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.809,
  cy: 111.723,
  stroke: "#307553",
  strokeWidth: 0.979,
  rx: 3.286,
  ry: 3.291
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.215,
  cy: 107.176,
  stroke: "#86B09B",
  strokeWidth: 0.979,
  rx: 1.878,
  ry: 1.881
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.878,
  cy: 97.96,
  stroke: "#86B09B",
  strokeWidth: 0.979,
  rx: 1.878,
  ry: 1.881
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.256,
  cy: 91.392,
  stroke: "#86B09B",
  strokeWidth: 0.979,
  rx: 3.286,
  ry: 3.291
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rocket_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h120v120H0z"
})))));
export default SvgRocket;